// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedUser: null
}

const publishers = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA':
      return {
        ...state,
        data: action.data,
        params: action.params
      }
    case 'GET_ROW':
      return { ...state, selectedRow: action.selectedRow }
    case 'ADD_USER':
      return { ...state }
    default:
      return { ...state }
  }
}
export default publishers
